import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import usePersonalData from '../../hooks/usePersonalData';

const ModalContactMe = ({ onClose, onSuccess }) => {
    const { getPersonalData } = usePersonalData();
    const overlayRef = useRef(null);
    const boxRef = useRef(null);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = null; };
    }, []);

    const handleOverlayClick = (e) => {
        if (boxRef.current && !boxRef.current.contains(e.target)) {
            onClose();
        }
    };

    const handleContactBy = async (contactMethod) => {
        const personalData = getPersonalData();
        try {
            await axios.put(
                `/api/kinto/forms/one_personal_update/${personalData.id}/`,
                { ...personalData, contact: contactMethod },
                { headers: { 'X-CSRFToken': document.querySelector('meta[name="csrf-token"]').content } }
            );
            dataLayer.push({
                event: 'trackEvent',
                eventCategory: 'cotizar_one_personal',
                eventAction: 'cta',
                eventLabel: 'contactar_asesor_' + contactMethod,
            });
            onSuccess();
        } catch (error) {
            console.error('Error al actualizar medio de contacto:', error);
            onSuccess();
        }
    };

    return (
        <section className="onepersonal-modal contact-me-modal">
            <div className="modal show" ref={overlayRef} onClick={handleOverlayClick}>
                <div className="modal-box" ref={boxRef}>
                    <div className="modal-header">
                        <h3 className="title3">¿Por qué medio te gustaría que te contactemos?</h3>
                        <span className="modal-close" onClick={onClose}>✕</span>
                    </div>
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="contact-me-options">
                                <button
                                    className="button --new --light contact-me-btn"
                                    onClick={() => handleContactBy('whatsapp')}>
                                    <img
                                        src={`${window._env_.STATIC_HOST}/static/website/images/icons/whatsapp-bw.svg`}
                                        alt="WhatsApp"
                                    />
                                    WhatsApp
                                </button>
                                <button
                                    className="button --new --light contact-me-btn"
                                    onClick={() => handleContactBy('telefono')}>
                                    <img
                                        src={`${window._env_.STATIC_HOST}/static/website/images/icons/speaker.svg`}
                                        alt="Teléfono"
                                    />
                                    Llamada telefónica
                                </button>
                                <button
                                    className="button --new --light contact-me-btn"
                                    onClick={() => handleContactBy('mail')}>
                                    <img
                                        src={`${window._env_.STATIC_HOST}/static/website/images/icons/inbox.svg`}
                                        alt="Email"
                                    />
                                    Email
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ModalContactMe;
